/* Ordiajade : refonte. Toucher le bandeau défilant le met en pause (ou le relance). */
document.addEventListener('click', function (event) {
  var bar = event.target.closest && event.target.closest('ticker-bar');
  if (!bar || event.target.closest('a')) return;
  bar.classList.toggle('is-paused');
});

/* Bouton Chat (Shopify Inbox) plus discret : petit rond avec l'icône seule.
   Le mot « Chat » reste lu par les lecteurs d'écran (aria-label du bouton).
   L'application reconstruit son bouton dans des couches internes (shadow DOM) quand on ouvre
   ou ferme la discussion : on surveille ces couches pour réappliquer le style à chaque fois. */
(function () {
  var css = '.activator { width: 44px !important; min-width: 44px !important; height: 44px !important; padding: 0 !important; justify-content: center !important; border-radius: 50% !important; }'
    + ' .activator__label { display: none !important; }'
    + ' .activator__icon { margin: 0 !important; }'
    /* Remonte au-dessus de la barre d'achat fixe des fiches produit quand elle est affichée (variable posée par ordiajade-barre-achat.js) */
    + ' .activator { transform: translateY(calc(-1 * var(--ordia-bar-decalage, 0px))) !important; transition: transform .3s ease !important; }';
  var surveillees = new WeakSet();

  function traiter(racine) {
    if (racine.querySelector('.activator') && !racine.querySelector('style[data-ordiajade]')) {
      var style = document.createElement('style');
      style.setAttribute('data-ordiajade', '');
      style.textContent = css;
      racine.appendChild(style);
    }
    if (!surveillees.has(racine)) {
      surveillees.add(racine);
      new MutationObserver(function () { traiter(racine); }).observe(racine, { childList: true, subtree: true });
    }
    racine.querySelectorAll('*').forEach(function (element) {
      if (element.shadowRoot) traiter(element.shadowRoot);
    });
  }

  function demarrer() {
    var chat = document.querySelector('shopify-chat');
    if (!chat || !chat.shadowRoot) return false;
    traiter(chat.shadowRoot);
    return true;
  }

  if (!demarrer()) {
    var essais = 0;
    var minuteur = setInterval(function () {
      if (demarrer() || ++essais > 40) clearInterval(minuteur);
    }, 500);
  }
})();

/* Vidéo story sous « Ajouter au panier » (snippets/ordiajade-video-story.liquid).
   Toujours sans son (choix de la propriétaire), même en plein écran.
   Lecture en boucle tant qu'elle est à l'écran (pause sinon, pour économiser la batterie) ;
   toucher la vidéo ou le bouton d'agrandissement la passe en plein écran.
   Si l'appareil demande moins d'animations, la vidéo ne démarre que lorsqu'on l'agrandit. */
if (window.customElements && !customElements.get('ordia-video-story')) {
  customElements.define('ordia-video-story', class extends HTMLElement {
    connectedCallback() {
      var video = this.querySelector('video');
      var agrandir = this.querySelector('.ordia-story__agrandir');
      if (!video || !agrandir || this.dataset.pret) return;
      this.dataset.pret = '1';

      var calme = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.removeAttribute('controls');
      if (calme) {
        video.removeAttribute('autoplay');
        video.pause();
      }
      /* Le lecteur plein écran de l'iPhone affiche son propre bouton de volume : on recoupe le son aussitôt */
      video.addEventListener('volumechange', function () {
        if (!video.muted) video.muted = true;
      });

      function lire() {
        var essai = video.play();
        if (essai && essai.catch) essai.catch(function () {});
      }
      function pleinEcran() {
        lire();
        if (video.requestFullscreen) {
          var plein = video.requestFullscreen();
          if (plein && plein.catch) plein.catch(function () {});
        } else if (video.webkitEnterFullscreen) {
          video.webkitEnterFullscreen();
        }
      }

      agrandir.addEventListener('click', pleinEcran);
      video.addEventListener('click', function () {
        if (document.fullscreenElement !== video) pleinEcran();
      });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entrees) {
          entrees.forEach(function (entree) {
            if (!entree.isIntersecting) video.pause();
            else if (!calme) lire();
          });
        }, { threshold: 0.25 }).observe(video);
      }
    }
  });
}
/* Onglet « Vu récemment » en bas de fiche (sections/ordiajade-meme-ton.liquid) : le thème enregistre le bijou de la page
   avant d'afficher la liste, il apparaissait donc dans son propre « Vu récemment ». On le retire ;
   s'il ne reste aucun autre bijou, l'onglet reste caché (règle .recent__wrapper.is-hidden dans ordiajade-refonte.css). */
document.addEventListener('theme:tab:check', function (event) {
  var section = event.target.closest && event.target.closest('.ordia-reco');
  if (!section) return;
  var wrapper = section.querySelector('.recent__wrapper');
  var courant = '/products/' + section.getAttribute('data-produit');
  if (!wrapper) return;
  wrapper.querySelectorAll('.product-item').forEach(function (item) {
    var lien = item.querySelector('a[href*="/products/"]');
    if (!lien) return;
    var chemin = new URL(lien.getAttribute('href'), window.location.origin).pathname;
    if (chemin.slice(-courant.length) === courant) item.remove();
  });
  if (!wrapper.querySelector('.product-item')) wrapper.classList.add('is-hidden');
}, true);
